import { version } from 'vue';

export const Vue3 = version.startsWith('3');
